module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetLow@2x.914e6e5.webp";